import { Box } from '@chakra-ui/react';
import React from 'react';

export const CardOne = (props) => {
  const { children, ...rest } = props;
  return (
    <Box
      {...rest}
      minHeight="5rem"
      minWidth="10rem"
      rounded="md"
      p={5}
      backgroundColor="white"
      boxShadow="xl"
    >
      {children}
    </Box>
  );
};
